import { CountryCode } from 'libphonenumber-js';

export type BillingContactInformationState = {
  firstName: string;
  lastName: string;
  phone: string;
  mobileNumber: string;
  phoneCountryCode?: CountryCode;
  email: string;
  isMobileNumberChecked: boolean;
};

export type AccountHolderInformationState = {
  firstName: string;
  lastName: string;
  phone: string;
  mobileNumber: string;
  phoneCountryCode?: CountryCode;
  email: string;
  isMobileNumberChecked: boolean;
};

export type OnSiteContactInformationState = {
  firstName: string;
  lastName: string;
  phone: string;
  mobileNumber: string;
  phoneCountryCode?: CountryCode;
  email: string;
  isMobileNumberChecked: boolean;
};

export type WorkOrderNotes = {
  firstName: string;
  lastName: string;
  phoneNumber: string;
  email: string;
};

export type BusinessInformationState = {
  name: string;
  taxID: string;
  SSN: string;
  shouldUseTaxid: boolean;
  billingContact: BillingContactInformationState;
  accountHolder: AccountHolderInformationState;
  onSiteContact: OnSiteContactInformationState;
  isBusinessInformationLoading: boolean;
  organizationPartyId: string;
  isTaxExempt: boolean;
};

export type ErrorPayload<T = string> = {
  callingSaga: string;
  err: T;
  payload: string | null;
};

export const initialBusinessInformationState: BusinessInformationState = {
  name: '',
  taxID: '',
  SSN: '',
  shouldUseTaxid: true,
  billingContact: {
    firstName: '',
    lastName: '',
    phone: '',
    mobileNumber: '',
    email: '',
    isMobileNumberChecked: false,
  },
  accountHolder: {
    firstName: '',
    lastName: '',
    phone: '',
    mobileNumber: '',
    email: '',
    isMobileNumberChecked: false,
  },
  onSiteContact: {
    firstName: '',
    lastName: '',
    phone: '',
    mobileNumber: '',
    email: '',
    isMobileNumberChecked: false,
  },
  isBusinessInformationLoading: false,
  organizationPartyId: '',
  isTaxExempt: false,
};
